import { __rest } from "tslib";
import * as React from 'react';
const ChevronUpSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M10.3495235,6.64669148 L10.3527131,6.65069148 L10.3561771,6.64781987 L11.0632839,7.35492665 L11.0597131,7.35769148 L16.3549267,12.6478199 L15.6478199,13.3549267 L10.3527131,8.06469148 L5.06181987,13.3549267 L4.35471309,12.6478199 L9.64571309,7.35769148 L9.64241676,7.35379826 L10.3495235,6.64669148 Z" })));
};
ChevronUpSmall.displayName = 'ChevronUpSmall';
export default ChevronUpSmall;
//# sourceMappingURL=ChevronUpSmall.js.map